import { Component, OnInit } from "@angular/core";
import { SidenavService } from "../services/sidenav.service";
import { Subscription } from "../../../../../node_modules/rxjs";
import { BackOfficeSession } from "src/app/Services/Api.BackOfficeSession/BackOfficeSession";
import { OpenModal } from "src/app/OpenModal";
import { TypeDialog, ButtonsDialog } from "src/app/model-type";
import { Perfil, Accion } from "../../../Models/Menu/Menu";
import { Globales } from "../../../Global";
import { Router } from '@angular/router';

@Component({
  selector: "app-navigation-left",
  templateUrl: "./navigation-left.component.html",
  styleUrls: ["./navigation-left.component.css"]
})
export class NavigationLeftComponent implements OnInit {
  subscription: Subscription;
  toggledMenu: boolean;
  container_wrapper: string;
  opened: boolean;
  acciones: any[] = [];

  constructor(
    private sidenavService: SidenavService,
    private _authenticationService: BackOfficeSession,
    private OModal: OpenModal,
    public globals: Globales,
    private router: Router
  ) {}

  toggleMenu(brand) {
    this.sidenavService.toggleMenu(brand);
  }

  toggleOpen(index: number) {
    this.sidenavService.toggleSelectSection(index);
  }

  ngOnInit(): void {
    this.obtenerMenu();
  }

  loadData(){
    
    this.acciones.forEach(accion=>{
      accion.hijos = this.acciones.filter( hijos => hijos.idAccionPadre == accion.accionID);
    });
    this.acciones = this.acciones.filter( accion => accion.idAccionPadre == 0);
  }

  obtenerMenu() {
    this._authenticationService.getMenu().subscribe(
      res => {
        const recordset = (res as any).record;
        if (recordset != null) {
          this.acciones = recordset.menus;
          this.loadData();
        } else {
          this.OModal.openDialog(
            TypeDialog.information,
            "Advertencia",
            "No fue posible obtener Menú",
            ButtonsDialog.ok,
            300
          );
        }
      },
      err => {
        if (err.status === 401) {
          this.router.navigate(["/login"]);
        }
      }
    );

    this.toggledMenu = false;
    this.container_wrapper = "container_wrapper";
    this.opened = true;

    this.subscription = this.sidenavService.menuToggle.subscribe(status => {
      this.opened = status;
    });

    this.subscription = this.sidenavService.containerClass.subscribe(status => {
      this.container_wrapper = status;
    });
  }
}
